import $ from 'jquery';
import {SidePanel} from './SidePanel';
import { show as showSelector } from "./AudienceSelector";
import CookieHelper from "../helpers/CookieHelper";

export class MobileNavigation extends SidePanel {
    constructor(referenceNavigationUl) {
        super({
            dismissOnResizeToDesktop: true
        });
        this.initTemplates(referenceNavigationUl);
    }

    initTemplates(referenceNavigationUl) {
        this.config = _.defaults({
            rootMenuLabel: 'Menu',
            menuTopBuffer: 90
        }, this.config);

        let searchClass = '';
        let searchUrlByCountryAudience = '';
        if(this.isAudienceSelected()) {
            searchClass = 'search-visible'
            searchUrlByCountryAudience = this.returnSearchUrl();
        }
        this.$template = $(`
            <div class="ar-mobile-menu-container">
                <div class="ar-mobile-menu-panel-wrapper"></div>
                <div class="ar-search-input ${searchClass}">
                    <form method="GET" action="${searchUrlByCountryAudience}" data-gtm-method="onGlobalSearch" name="global-search">
                        <input class="ar-search-input-input" title="Search" type="search" name="q" placeholder="Search" />
                        <button class="ar-search-input-btn" title="Click to search">
                            <svg width="28px" height="28px" viewBox="292 11 28 28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs></defs>
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(293.000000, 11.000000)">
                                    <g fill="#FFFFFF">
                                        <path d="M14.3492307,6.04270498 C13.1477749,4.86495365 11.5517635,4.21645981 9.85485308,4.2170443 C9.56586215,4.2170443 9.33169494,4.45171783 9.33169494,4.74191809 C9.33169494,5.03153386 9.56644539,5.26649964 9.85485308,5.26620739 C11.2764785,5.26620739 12.6123689,5.80803145 13.6166926,6.79319267 C14.6178085,7.77455469 15.1689617,9.07826404 15.1692533,10.4643868 C15.1692533,10.7542948 15.4037122,10.9892605 15.6929947,10.9892605 C15.8373444,10.9892605 15.9682797,10.9305191 16.0633464,10.8355392 C16.158413,10.7405592 16.2167361,10.609633 16.2167361,10.4643868 C16.2167361,8.79361645 15.5530193,7.22337876 14.3492307,6.04270498 L14.3492307,6.04270498 Z"></path>
                                        <path d="M19.4540312,17.6382698 C19.1810791,17.3647276 18.648006,17.1432051 18.2621988,17.1432051 L17.8982627,17.1432051 L17.064534,16.3067971 C18.4499991,14.5895597 19.2172394,12.4798359 19.2414435,10.2628578 C19.2697302,7.683787 18.2919435,5.26837392 16.4891767,3.46229373 C12.7751621,-0.259751159 6.67135881,-0.19925624 2.88094098,3.59935709 C-0.907143937,7.39592471 -0.967508339,13.5135099 2.74679786,17.2358471 C4.54839821,19.0419273 6.95801682,20.0209513 9.53210654,19.9928957 C11.7445931,19.9689315 13.8497651,19.2000324 15.5632976,17.8112794 L16.3979011,18.6476874 L16.3979011,19.0103647 C16.3979011,19.3970061 16.6192372,19.9312318 16.8918977,20.2047741 L23.1522985,26.4807566 C23.8597577,27.1888686 25.0069729,27.1885764 25.714432,26.4795876 C26.4218911,25.7703066 26.4224744,24.6206109 25.7153069,23.9124989 L19.4540312,17.6382698 L19.4540312,17.6382698 Z M15.1206253,15.8631677 C13.6115153,17.3752484 11.6197817,18.2207161 9.51315154,18.2438035 C7.41293694,18.2668909 5.44832354,17.4699361 3.98091452,15.9987698 C0.947238816,12.9585348 1.00701999,7.95060759 4.11709894,4.83409639 C7.22484497,1.71933866 12.2210928,1.65913599 15.2547685,4.6987865 C16.7230523,6.16966055 17.5188709,8.138814 17.4964166,10.2435696 C17.4725041,12.3553391 16.6291522,14.3507947 15.1206253,15.8631677 L15.1206253,15.8631677 Z"></path>
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </form>
                </div>
            </div>
        `);

        this.panelTemplate = _.template(`
            <div class="ar-mobile-menu-panel">
                <header>
                <% if(key === 'root'){ %>
                    <h3><%= menuLabel %></h3>
                <% }else{ %>
                    <h3 class="ar-submenu">
                        <button class="ar-mobile-child-menu-btn" data-menu-key="<%- parentKey %>" data-direction="backwards"><span class="icon-arrow-left"></span></button>
                        <%= menuLabel %>
                    </h3>
                <% } %>
                </header>
                <ul class="ar-mobile-menu-panel-list">
                    <%= links %>
                </ul>
            </div>
        `);

        this.linkTemplate = _.template(`
            <li class="<% if(hasChildren){ %>has-children<% }%> <% if(key.includes('my-artemis')){ %>my-artemis-link<% }%><% if(key.includes('my-account')){ %>my-account-link<% }%>">
                <a href="<%- url %>" data-gtm-attributes="|event|:|link_click|,|eventName|:|navigation_click|,|widget_format|:|<%- parentTitle == "Home" ? "main nav" : "sub nav" %>|,|widget_type|:|primary menu|"><%- label %></a>
                <% if(hasChildren){ %>
                    <button class="ar-mobile-child-menu-btn" data-menu-key="<%- key %>" data-direction="forward"><span class="icon-arrow-right"></span></button>
                <% }%>
            </li>`);

        this.$panelContainer = this.$template.find('.ar-mobile-menu-panel-wrapper');
        this.$referenceNavigationUl = $(referenceNavigationUl).clone();

        this.prepareLinksForMobileMenu(this.$referenceNavigationUl);

        this.$menuLoginButton = $(`<a class="ar-login-mobile${window.audienceProfileIsEmpty ? ' ar-audience-enforced-link' : ''}" href="/en/my-artemis">${window.userLoggedIn ? 'My Artemis' : 'Login'}</a>`);
        this.$menuToggleButton = $('<button class="ar-mobile-nav-menu-btn" title="Open or close navigation menu"><span class="icon-menu"></span></button>');
        this.$header.find('.ar-header-navigation').append(this.$menuToggleButton).append(this.$menuLoginButton);

        //ON mobile nav click, notify the MobileNavigation
        this.$menuToggleButton.on('click', this.toggle.bind(this));

        this.initMobileMenu();
    }

    isAudienceSelected() {
        return !window.audienceProfileIsEmpty;
    }

    returnSearchUrl() {
        const cookie = CookieHelper.getCookie();
        let profileCountry = '';
        let profileType = '';
        profileCountry = cookie.artweb_country;
        switch (String(cookie.artweb_investorType).toLowerCase())
        {
            case 'pvi':
                profileType = 'investor';
                break;

            case 'ic':
                profileType = 'institution';
                break;

            case 'pfi':
                profileType = 'professional';
                break;

            case 'qi':
                profileType = 'qualified';
                break;
            
            case 'fim':
                profileType = 'intermediary';
                break;

            default:
                profileType = 'adviser';
        }
        return `/${profileCountry}/${profileType}/search`;
    }

    prepareLinksForMobileMenu(existingMenuElement) {
        // menu when user is not log in
        if ($('.ar-account-list-type__link').length > 1) {
            var menuNotLogIn = "";
            _.each($('.ar-account-list-type__link'), (element, key) => {
                menuNotLogIn += "<li><a href='" + $(element).attr('href') + "'>" + $(element).find('.ar-account-list-type__header').text().trim() + "</a></li>";
            });

            $(existingMenuElement).prepend(menuNotLogIn);
        }

        // menu when user is logged
        if ($('a.ar-myartemis-link').length > 1) {
            var menuLogged = "";

            _.each($('a.ar-myartemis-link'), (element, key) => {
                if ($(element).hasClass('ar-myaccount-link')) {
                    var myAccount = "<li><a href='" + $(element).attr('href') + "'>" + $(element).text().trim() + "</a></li>";
                    $(existingMenuElement).prepend(myAccount);
                    return;
                }

                if (key == 0) {
                    menuLogged = "<li class='has-children'><a href='"+ $('a.ar-myartemis-link').first().attr('href') +"'>"+ $('a.ar-myartemis-link').first().text() + "</a><ul>";
                    return;
                } 

                if ($(element).hasClass('ar-myaccount-link')) {
                    return;
                } 
                if($(element).hasClass('ar-myartemis-link--close')) {
                    return;
                } 

                menuLogged += "<li><a href='" + $(element).attr('href') + "'>" + $(element).text() + "</a></li>";
            });

            menuLogged += "</ul></li>";
            $(existingMenuElement).prepend(menuLogged);
        }
    }

    initMobileMenu() {
        this._applyKeysToReferenceUl();
        this.$panelContainer.on('click', 'button.ar-mobile-child-menu-btn', this._onSubMenuBtnClick.bind(this))

        this.$root.append(this.$template);

        this._checkIfShowAudienceSelectorPopup()
    }

    _checkIfShowAudienceSelectorPopup() {
        if(window.audienceProfileIsEmpty) {
            this.$panelContainer.on('click', 'a', (e) => {
                if(e.currentTarget.getAttribute("href") === '#') {
                    e.preventDefault(); showSelector();
                }
            });
        }
    }

    _showPanel() {
        this.$menuToggleButton.children('.icon-menu').removeClass('icon-menu').addClass('icon-cross');
        return this._renderInitialMenu().then(super._showPanel.bind(this));
    }

    _hidePanel() {
        this.$menuToggleButton.children('.icon-cross').removeClass('icon-cross').addClass('icon-menu');
        $('.ar-mobile-menu-container').removeClass('my-artemis-submenu');
        return super._hidePanel();
    }

    _renderInitialMenu(key) {
        return this._buildPanel('root').then(($panel)=>{
            this.$panelContainer.empty().append($panel);
        });
    }

    _buildPanel(key){
        var $panel;
        var parentKey = this._getParentKeyForKey(key);
        var menuLabel = this._getLabelForKey(key);
        var menuItems = this._getMenuItemsForKey(key);
        var linkStrings = [];

        _.each(menuItems, (item, index) => {
            linkStrings.push(this.linkTemplate(item))
        });

        $panel = $(this.panelTemplate({
            menuLabel: menuLabel,
            key: key,
            parentKey: parentKey,
            links: linkStrings.join('')
        }));

        return Promise.resolve($panel);
    }

    _animateToSubmenu(key, direction){

        this._buildPanel(key).then(($newMenu) => {

            //Measure initial positions
            this.$panelContainer.append($newMenu);

            var panelContainerEl = this.$panelContainer[0];
            var panelContainerClientRect = panelContainerEl.getBoundingClientRect();
            var $currentMenu = this.$panelContainer.children().eq(0);
            var currentMenuEl = $currentMenu[0];
            var currentMenuClientRect = currentMenuEl.getBoundingClientRect();
            var newMenuEl = $newMenu[0];
            var newMenuElClientRect = newMenuEl.getBoundingClientRect();

            //Set final positions

            if(direction === 'forward'){
                //Parent container
                panelContainerEl.style['position'] = 'relative';
                panelContainerEl.style['width'] = (currentMenuClientRect.width*2) + 'px';
                panelContainerEl.style['left'] = (-currentMenuClientRect.width) + 'px';
                panelContainerEl.style['height'] = Math.max(currentMenuClientRect.height, newMenuElClientRect.height) + 'px';


                //Children
                currentMenuEl.style['position'] = 'absolute';
                currentMenuEl.style['left'] = '0px';
                currentMenuEl.style['top'] = '0px';
                currentMenuEl.style['width'] = currentMenuClientRect.width + 'px';

                newMenuEl.style['position'] = 'absolute';
                newMenuEl.style['right'] = '0px';
                newMenuEl.style['top'] = '0px';
                newMenuEl.style['width'] = currentMenuClientRect.width + 'px';

                panelContainerEl.style['transform'] = 'translate3d('+currentMenuClientRect.width+'px,0,0)';
                panelContainerEl.style['-webkit-transform'] = 'translate3d('+currentMenuClientRect.width+'px,0,0)';
            } else {

                //Parent container
                panelContainerEl.style['position'] = 'relative';
                panelContainerEl.style['width'] = (currentMenuClientRect.width*2) + 'px';
                panelContainerEl.style['left'] = '0px';
                panelContainerEl.style['height'] = Math.max(currentMenuClientRect.height, newMenuElClientRect.height) + 'px';


                //Children
                currentMenuEl.style['position'] = 'absolute';
                currentMenuEl.style['right'] = '0px';
                currentMenuEl.style['top'] = '0px';
                currentMenuEl.style['width'] = currentMenuClientRect.width + 'px';

                newMenuEl.style['position'] = 'absolute';
                newMenuEl.style['left'] = '0px';
                newMenuEl.style['top'] = '0px';
                newMenuEl.style['width'] = currentMenuClientRect.width + 'px';

                panelContainerEl.style['transform'] = 'translate3d(-'+currentMenuClientRect.width+'px,0,0)';
                panelContainerEl.style['-webkit-transform'] = 'translate3d(-'+currentMenuClientRect.width+'px,0,0)';
            }


            panelContainerClientRect = panelContainerEl.getBoundingClientRect();

            return new Promise((resolve, reject)=>{
                requestAnimationFrame(() => {

                    //Switch on animation
                    this.$panelContainer.addClass('animate-on-transforms');

                    //Play animation
                    panelContainerEl.style['transform'] = '';
                    panelContainerEl.style['-webkit-transform'] = '';

                    setTimeout(()=>{

                        $currentMenu.remove();
                        this.$panelContainer.removeClass('animate-on-transforms');

                        panelContainerEl.style['position'] = 'static';
                        panelContainerEl.style['width'] = 'auto';
                        panelContainerEl.style['left'] = 'auto';
                        panelContainerEl.style['right'] = 'auto';
                        panelContainerEl.style['height'] = 'auto';

                        newMenuEl.style['position'] = 'static';
                        newMenuEl.style['left'] = 'auto';
                        newMenuEl.style['right'] = 'auto';
                        newMenuEl.style['top'] = 'auto';
                        newMenuEl.style['width'] = 'auto';

                        resolve();

                    }, this.config.animationDuration)
                })
            });
        })

    }

    _getParentKeyForKey(key){
        if(key === 'root'){
            return 'root';
        }
        var $anchor = this.$referenceNavigationUl.find('.ar-key-' + key).closest('ul').siblings('a');

        //If the sibling anchor could not be found, the parent is root
        if($anchor.length === 0){
            return 'root';
        }
        return $anchor.data('key');
    }

    _getLabelForKey(key){
        if (key === 'root') {
            return this.config.rootMenuLabel;
        } else {
            return this.$referenceNavigationUl.find('.ar-key-' + key).text();
        }
    }

    _getMenuItemsForKey(key) {
        var $selectedUl, links = [];

        if (key === 'root') {
            $selectedUl = this.$referenceNavigationUl;
        } else {
            $selectedUl = this.$referenceNavigationUl.find('.ar-key-' + key).siblings('ul');
        }

        $selectedUl.find('> li > a').each((i, element) =>{
            links.push({
                label: $(element).text(),
                key: $(element).data('key'),
                url: $(element).attr('href'),
                parentTitle: $(element).attr('data-parent-title'),
                hasChildren: $(element).parent().hasClass('has-children')
            })
        });

        return links;
    }

    _applyKeysToReferenceUl(){
        this.$referenceNavigationUl.find('a').each((i, element) => {
            const $el = $(element);
            const key = _.uniqueId(_.kebabCase($(element).text()) + "-");

            $el
                .data('key', key)
                .addClass('ar-key-' + key);
        })
    }

    _onSubMenuBtnClick(e){
        var $button = $(e.target);
        var $container = $('.ar-mobile-menu-container');

        if(!$button.hasClass('ar-mobile-child-menu-btn')){
            $button = $button.closest('.ar-mobile-child-menu-btn')
        }
        var menuKey = $button.data('menuKey');
        
        this._animateToSubmenu(menuKey, $button.data('direction'));
        
        if (menuKey === 'my-artemis-1') {
            $container.addClass('my-artemis-submenu');
        } else {
            $container.removeClass('my-artemis-submenu');
        }
    }
}

MobileNavigation.create = function () {
    return new MobileNavigation('.ar-header-primary-nav > ul');
};